import { render, staticRenderFns } from "./StatusPage.vue?vue&type=template&id=38344982&scoped=true&lang=html"
import script from "./StatusPage.vue?vue&type=script&lang=js"
export * from "./StatusPage.vue?vue&type=script&lang=js"
import style0 from "./StatusPage.vue?vue&type=style&index=0&id=38344982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38344982",
  null
  
)

export default component.exports